"use client";

import { type JSX } from "react";
import { Placeholder } from "@sitecore-content-sdk/nextjs";
import { ClientOnly } from "../../../atoms/ClientOnly";
import {
  SearchEngineProvider,
  usePageSearchEngine,
} from "../../../hooks/useSearchEngine";
import { AtomicPageWrapper } from "lib/search/AtomicPageWrapper";
import { type SearchContainerProps } from "./search-container.props";

export const Default = (props: SearchContainerProps): JSX.Element => {
  console.log("---->[SearchContainer:Default] Component", props);

  const { rendering, fields, params, page } = props;

  // Default to true so the URL preserves facet selections; authors can
  // explicitly set it to "false" in Sitecore to opt out.
  const reflectStateInUrl = params?.ReflectStateInUrl !== "false";
  const searchPageKey =
    page?.layout?.sitecore?.route?.itemId?.toString() ??
    params?.RenderingIdentifier ??
    "search-page";
  const searchEngine = usePageSearchEngine(params?.SearchScope, searchPageKey);
  const fieldsToInclude =
    fields?.FieldsToInclude?.map((field) => field.name) ?? [];
  const phKey = `searchcontainer-${params?.DynamicPlaceholderId ?? ""}`;

  console.log("SearchContainer-Coveo page key:", {
    searchPageKey,
    scope: params?.SearchScope,
    routeId: page?.layout?.sitecore?.route?.itemId,
  });

  return (
    <ClientOnly>
      <SearchEngineProvider key={searchPageKey} engine={searchEngine}>
        <AtomicPageWrapper
          key={searchPageKey}
          engine={searchEngine}
          reflectStateInUrl={reflectStateInUrl}
          fieldsToInclude={fieldsToInclude}
        >
          <Placeholder name={phKey} rendering={rendering} />
        </AtomicPageWrapper>
      </SearchEngineProvider>
    </ClientOnly>
  );
};
